<template>
  <div style="margin-top: 30px; padding:11px;">

    <div class="header-container">
      <!-- Sol taraf - Personel Ekle -->
      <div class="left-section">
        <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
          Personel Ekle
        </button>
      </div>

      <!-- Orta kısım - Arama -->
      <div class="center-section">
        <input
            type="text"
            v-model="searchQuery"
            class="form-control search-input"
            placeholder="Ara..."
        >
      </div>

      <!-- Sağ taraf - Filtre ve Excel -->
      <div class="right-section">
        <div class="btn-group me-2" role="group">
          <button
              type="button"
              class="btn"
              :class="filterType === 'all' ? 'btn-primary' : 'btn-outline-primary'"
              @click="setFilterType('all')"
          >
            Tümü
          </button>
          <button
              type="button"
              class="btn"
              :class="filterType === 'working' ? 'btn-primary' : 'btn-outline-primary'"
              @click="setFilterType('working')"
          >
            Aktif Çalışanlar
          </button>
          <button
              type="button"
              class="btn"
              :class="filterType === 'terminated' ? 'btn-primary' : 'btn-outline-primary'"
              @click="setFilterType('terminated')"
          >
            İşten Çıkanlar
          </button>
        </div>
        <button
            type="button"
            class="btn btn-secondary"
            data-bs-toggle="modal"
            data-bs-target="#filterModal"
        >
          Filtre
        </button>
        <button
            type="button"
            class="btn btn-success ms-2"
            @click="exportToExcel"
        >
          Excel'e Aktar
        </button>
      </div>
    </div>


    <br>
    <div class="modal fade" id="filterModal" tabindex="-1" aria-labelledby="filterModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="filterModalLabel">Gösterilecek Alanları Seçin</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="form-check" v-for="(value, key) in fieldsVisibility" :key="key">
              <input class="form-check-input" type="checkbox" v-model="fieldsVisibility[key]" :id="key">
              <label class="form-check-label" :for="key">{{ fieldLabels[key] }}</label>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Kapat</button>
            <button type="button" class="btn btn-primary" @click="applyFilters" data-bs-dismiss="modal">Uygula</button>
          </div>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table align-middle">
        <thead>
        <tr>
          <td v-if="fieldsVisibility.name" @click="sortByName" style="cursor: pointer;">
            Ad Soyad
            <span v-if="sortOrder === 'asc'"> 🔼</span>
            <span v-if="sortOrder === 'desc'"> 🔽</span>
          </td>
          <td v-if="fieldsVisibility.role">Ünvan</td>
          <td v-if="fieldsVisibility.workOrRetired">Emekli Durumu</td>
          <td v-if="fieldsVisibility.workedHours">Personel Çalışma Saati</td>
          <td v-if="fieldsVisibility.workType">Çalışma Tipi</td>
          <td v-if="fieldsVisibility.personalStartDate">İşe Başlama Tarihi</td>
          <td v-if="fieldsVisibility.personalEndDate">İşten Çıkış Tarihi</td>
          <td>İşlemler</td>
        </tr>
        </thead>

        <tbody>
        <tr v-for="val in paginatedData" :key="val.id">
          <td v-if="fieldsVisibility.name">
            <router-link
                :to="{ name: 'PersonalDetails', params: { id: val.id }}"
                class="personal-link"
            >
              {{ val.name }}
            </router-link>
          </td>
          <td v-if="fieldsVisibility.role">{{ val.role ? val.role.roleName : '' }}</td>
          <td v-if="fieldsVisibility.workOrRetired">
            <div v-show="val.workOrRetired === true">Emekli</div>
            <div v-show="val.workOrRetired === false">Emekli Değil</div>
          </td>
          <td v-if="fieldsVisibility.workedHours">{{ val.workedHours }}</td>
          <td v-if="fieldsVisibility.workType">
            <div v-show="val.workType === true">Tam Zamanlı</div>
            <div v-show="val.workType === false">Yarı Zamanlı</div>
          </td>
          <td v-if="fieldsVisibility.personalStartDate">{{ formatDate(val.personalStartDate) }}</td>
          <td v-if="fieldsVisibility.personalEndDate">
            <span v-if="val.personalEndDate" class="text-danger">{{ formatDate(val.personalEndDate) }}</span>
            <span v-else class="text-success">Aktif</span>
          </td>
          <td>
            <!--
            <button type="button" class="btn btn-danger"
                    data-bs-toggle="modal"
                    data-bs-target="#PersonalDeleteModal"
                    @click="setDeleteId(val.id)">Sil</button>
            -->
            &nbsp;
            <button type="button" class="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="editPersonal(val.id)">Düzenle</button>
            <div class="modal fade" id="PersonalDeleteModal" tabindex="-1" aria-labelledby="PersonalDeleteModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="PersonalDeleteModalLabel">Silme Onayı</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                    <p>Bu öğeyi silmek istediğinizden emin misiniz?</p>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">İptal</button>
                    <button type="button" class="btn btn-danger" data-bs-dismiss="modal" @click="PersonalDelete(deleteId)">Evet, Sil</button>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <button @click="prevPage" :disabled="currentPage === 1">Önceki</button>
      <span>Sayfa {{ currentPage }} / {{ totalPages }}</span>
      <button @click="nextPage" :disabled="currentPage === totalPages">Sonraki</button>
    </div>

    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel"> {{ isEditing ? 'Personel Düzenle' : 'Personel Ekle' }}</h5>
            <button type="button" class="btn-close" @click="showCloseConfirmation"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label for="exampleFormControlInput1" class="form-label">Personel Adı Soyadı</label>
              <input type="text" class="form-control" v-model="items.name" id="exampleFormControlInput1" placeholder="Personel Adı Soyadı">
            </div>
            <hr>
            <div class="mb-3">
              <label class="form-check-label" for="flexRadioDefault1">
                Role
              </label>
              <select class="form-select" v-model="items.role"   aria-label="Roller">
                <option value="0"></option>
                <option v-for="val in roles" v-bind:key="val.id" :value="val.id">{{ val.roleName }} {{ val.dangerType }}</option>
              </select>
            </div>
            <hr>

            <div class="form-check">
              <input class="form-check-input"
                     type="radio"
                     name="workType"
                     v-model="items.workType"
                     :value="false"
                     id="partTime"
                     @change="partTime">
              <label class="form-check-label" for="partTime">Yarı Zamanlı</label>
            </div>

            <div class="form-check">
              <input class="form-check-input"
                     type="radio"
                     name="workType"
                     v-model="items.workType"
                     :value="true"
                     id="fullTime"
                     @change="fullTime">
              <label class="form-check-label" for="fullTime">Tam Zamanlı</label>
            </div>
            <hr>
            <div class="mb-3">
              <label for="exampleFormControlInput1" class="form-label">Personel Çalışma Saati</label>
              <input type="number"
                     class="form-control"
                     v-model="items.workedHours"
                     id="exampleFormControlInput1"
                     placeholder="Personel Çalışma Saati"
                     :disabled="items.workType === true"
                     @input="validateWorkedHours">
              <small v-if="workedHoursError" class="text-danger">{{ workedHoursError }}</small>
            </div>
            <hr>
            <div class="form-check">
              <label class="form-check-label" for="flexRadioDefault2">
                İşe Giriş Tarihi
              </label>
              <input class="form-control" v-model="items.personalStartDate" type="date" name="flexRadioDefault" id="flexRadioDefault2" checked>
            </div>

            <div class="form-check">
              <label class="form-check-label" for="flexRadioDefault2">
                İşten Çıkış Tarihi
              </label>
              <input class="form-control" v-model="items.personalEndDate" type="date" name="flexRadioDefault" id="flexRadioDefault2" checked>
            </div>
            <hr>
            <div class="form-check">
              <input class="form-check-input"
                     type="checkbox"
                     id="flexCheckDefault"
                     v-model="items.workOrRetired">
              <label class="form-check-label" for="flexCheckDefault">
                Emekli
              </label>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="showCloseConfirmation">Vazgeç</button>
            <button type="button" class="btn btn-primary" @click="isEditing ? updatePersonal() : saveItems()">
              {{ isEditing ? 'Güncelle' : 'Kaydet' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Personel Ekle/Düzenle Modal Kapatma Onay Modalı -->
    <div class="modal fade" id="closeConfirmationModal" tabindex="-1" aria-labelledby="closeConfirmationModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="closeConfirmationModalLabel">Kapatma Onayı</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>Formu kapatmak istediğinize emin misiniz? Kaydedilmemiş değişiklikler kaybolacaktır.</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Hayır, Devam Et</button>
            <button type="button" class="btn btn-danger" @click="closePersonalModal">Evet, Kapat</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ts-nocheck
import apiClient from "@/axios";
import * as XLSX from "xlsx";
import * as bootstrap from 'bootstrap';

export default {
  name: "Users",
  data() {
    return {
      searchQuery: "",
      sortOrder: "asc",
      currentPage: 1,
      itemsPerPage: 10,
      personalModal: null,
      closeConfirmationModal: null,
      fieldsVisibility: {
        name: true,
        role: true,
        workType: true,
        workedHours: true,
        personalStartDate: true,
        personalEndDate: true,
        workOrRetired: true
      },
      fieldLabels: {
        name: 'Ad Soyad',
        role: 'Ünvan',
        workType: 'Çalışma Tipi',
        workedHours: 'Çalışma Saati',
        personalStartDate: 'İşe Başlama Tarihi',
        personalEndDate: 'İşten Çıkış Tarihi',
        workOrRetired: 'Emekli Durumu'
      },
      isEditing: false,
      roles: [],
      isMainCompany: false,
      data: [],
      items: { workOrRetired: false, workType: true, workedHours: 195 },
      itemsExpenses: { workOrRetired: false, seniorityBurden: false },
      personelData: [],
      workedHoursError: "",
      filterType: 'all', // 'all', 'working', 'terminated'
    };
  },
  computed: {
    filteredData() {
      let filtered = this.data;
      if (this.filterType === 'working') {
        filtered = this.data.filter(personel => !personel.personalEndDate);
      } else if (this.filterType === 'terminated') {
        filtered = this.data.filter(personel => personel.personalEndDate);
      }
      const normalizedTerm = this.normalizeSearch(this.searchQuery);
      return filtered.filter(personel =>
          personel.name && this.normalizeSearch(personel.name).includes(normalizedTerm)
      );
    },
    totalPages() {
      return Math.ceil(this.filteredData.length / this.itemsPerPage);
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredData.slice(start, start + this.itemsPerPage);
    },
  },
  created() {
    this.getData();
    this.getRoleData();
    this.getCompaniesData();
  },
  mounted() {
    // Bootstrap modal nesnelerini oluştur
    this.$nextTick(() => {
      this.personalModal = new bootstrap.Modal(document.getElementById('exampleModal'));
      this.closeConfirmationModal = new bootstrap.Modal(document.getElementById('closeConfirmationModal'));

      // Modal kapatma event'lerini dinle
      const modalElement = document.getElementById('exampleModal');
      if (modalElement) {
        modalElement.addEventListener('hidden.bs.modal', () => {
          this.cleanupModal();
        });
      }
    });
  },
  methods: {
    normalizeSearch(value) {
      if (value === null || value === undefined) {
        return "";
      }
      return String(value).toLocaleLowerCase("tr-TR");
    },
    cleanupModal() {
      // Modal kapatıldıktan sonra temizlik işlemleri
      // Scroll pozisyonunu korumak için daha güvenilir yaklaşım
      const scrollY = window.scrollY;

      document.querySelectorAll('.modal-backdrop').forEach(backdrop => {
        backdrop.remove();
      });
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';

      // Scroll pozisyonunu geri yükle
      window.scrollTo(0, scrollY);
    },
    showCloseConfirmation() {
      // Kapatma onay modalını göster
      this.closeConfirmationModal.show();
    },
    closePersonalModal() {
      // Onay modalını kapat
      this.closeConfirmationModal.hide();

      // Ana modalı kapat
      if (this.personalModal) {
        this.personalModal.hide();
      } else {
        // Fallback olarak DOM üzerinden modalı kapat
        const modal = document.getElementById('exampleModal');
        const modalInstance = bootstrap.Modal.getInstance(modal);
        if (modalInstance) {
          modalInstance.hide();
        }
      }

      // cleanupModal metodu hidden.bs.modal event'i ile otomatik çağrılacak

      // Formu sıfırla
      this.setItemsNull();
      this.isEditing = false;
    },
    sortByName() {
      if (this.sortOrder === "asc") {
        this.data.sort((a, b) => a.name.localeCompare(b.name, "tr"));
        this.sortOrder = "desc"; // Bir sonraki tıklamada Z-A sıralayacak
      } else {
        this.data.sort((a, b) => b.name.localeCompare(a.name, "tr"));
        this.sortOrder = "asc"; // Bir sonraki tıklamada A-Z sıralayacak
      }
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },
    applyFilters() {
      this.getData();
    },
    exportToExcel() {
      const visibleFields = {
        "Adı Soyadı": this.fieldsVisibility.name,
        "Rolü": this.fieldsVisibility.role,
        "Çalışma Tipi": this.fieldsVisibility.workType,
        "Çalışma Saati": this.fieldsVisibility.workedHours,
        "İşe Başlama Tarihi": this.fieldsVisibility.personalStartDate,
        "İşten Ayrılma Tarihi": this.fieldsVisibility.personalEndDate,
        "Emekli Durumu": this.fieldsVisibility.workOrRetired,
      };
      const data = this.personelData.map(personel => {
        let row = {};
        if (visibleFields["Adı Soyadı"]) row["Adı Soyadı"] = personel.name;
        if (visibleFields["Rolü"]) row["Rolü"] = personel.role ? personel.role.roleName : '';
        if (visibleFields["Çalışma Tipi"]) row["Çalışma Tipi"] = personel.workType ? "Tam Zamanlı" : "Yarı Zamanlı";
        if (visibleFields["Çalışma Saati"]) row["Çalışma Saati"] = personel.workedHours;
        if (visibleFields["İşe Başlama Tarihi"]) row["İşe Başlama Tarihi"] = this.formatDate(personel.personalStartDate);
        if (visibleFields["İşten Ayrılma Tarihi"]) row["İşten Ayrılma Tarihi"] = this.formatDate(personel.personalEndDate);
        if (visibleFields["Emekli Durumu"]) row["Emekli Durumu"] = personel.workOrRetired ? "Emekli" : "Emekli Değil";
        return row;
      });
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Personeller");
      XLSX.writeFile(workbook, "Personel_Bilgileri.xlsx");
    },
    validateWorkedHours() {
      if (this.items.workedHours < 0 || this.items.workedHours > 195) {
        this.workedHoursError = "Çalışma saati 0 ile 195 arasında olmalıdır!";
        this.items.workedHours = Math.max(0, Math.min(this.items.workedHours, 195));
      } else {
        this.workedHoursError = "";
      }
    },
    fullTime() {
      this.items.workType = true;
      this.items.workedHours = 195;
    },
    partTime() {
      this.items.workType = false;
      this.items.workedHours = 0;
    },
    formatDate(dateString) {
      if (!dateString) {
        return 'Tarih Girilmemiştir';
      }
      const date = new Date(dateString);
      const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      return date.toLocaleDateString('tr-TR', options); // 'tr-TR' ile Türk formatı
    },
    getCompaniesData() {
      apiClient.get("companies/all").then(res => {
        this.companiesData = res.data;
      });
    },
    getRoleData(){
      apiClient.get('/definition-personal-roles').then(res => {
        this.roles = res.data;
      })
    },
    getData() {
      apiClient.get('/personal').then(res => {
        this.data = res.data;
        this.personelData = res.data;
      });
    },
    saveItems() {
      const selectedRole = this.roles.find(role => role.id === this.items.role);
      if (selectedRole) {
        this.items.roleName = selectedRole.roleName;
      }

      this.items.companies = { id: this.items.companies };
      this.items.role = { id: this.items.role };
      let resultItems = {
        "personalData": this.items,
        "personalExpensesData": this.itemsExpenses
      };

      apiClient.post('/personal', resultItems).then(res => {
        if (res.data) {
          this.getData();
          this.setItemsNull();

          // Modal'ı kapat
          if (this.personalModal) {
            this.personalModal.hide();
          } else {
            // Fallback olarak DOM üzerinden modalı kapat
            const modal = document.getElementById('exampleModal');
            const modalInstance = bootstrap.Modal.getInstance(modal);
            if (modalInstance) {
              modalInstance.hide();
            }
          }

          // cleanupModal metodu hidden.bs.modal event'i ile otomatik çağrılacak
        }
      });
    },
    updatePersonal(){
      this.items.role = { id: this.items.role };
      apiClient.put(`/personal/${this.items.id}`, this.items).then(() => {
        this.getData();
        this.isEditing = false;

        // Modal'ı kapat
        if (this.personalModal) {
          this.personalModal.hide();
        } else {
          // Fallback olarak DOM üzerinden modalı kapat
          const modal = document.getElementById('exampleModal');
          const modalInstance = bootstrap.Modal.getInstance(modal);
          if (modalInstance) {
            modalInstance.hide();
          }
        }

        // cleanupModal metodu hidden.bs.modal event'i ile otomatik çağrılacak
      })
    },
    editPersonal(id) {
      apiClient.get(`/personal/${id}`).then(res => {
        this.items = { ...res.data };
        this.items.personalStartDate = this.items.personalStartDate
            ? this.items.personalStartDate.split(" ")[0]
            : null;
        this.items.personalEndDate = this.items.personalEndDate
            ? this.items.personalEndDate.split(" ")[0]
            : null;
        this.items.role = this.items.role ? this.items.role.id : null;
        this.items.workType = res.data.workType;
        this.isEditing = true;
      }).catch(error => {
        console.error("Personel verisi alınırken hata oluştu:", error);
      });
    },
    setDeleteId(id) {
      this.deleteId = id;
    },
    PersonalDelete(id) {
      apiClient.delete(`/personal/${id}`)
          .then(() => {
            this.getData();
          })
          .catch(error => {
            console.error("Silme işlemi sırasında hata oluştu:", error);
          });
    },
    setItemsNull() {
      this.items = {}
      this.itemsExpenses = {}
      this.items = { workOrRetired: false, workType: true };
      this.itemsExpenses = { workOrRetired: false, seniorityBurden: false };
      this.workedHoursError = "";
    },
    setFilterType(type) {
      this.filterType = type;
      this.currentPage = 1; // Sayfayı sıfırla
    }
  }
}
</script>

<style scoped>
input[type="date"] {
  appearance: none; /* Tarayıcı varsayılan stilini kaldırır */
  -webkit-appearance: none; /* Safari için */
  background-color: #f9f9f9;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 16px;
  font-family: 'Arial', sans-serif;
  color: #333;
  outline: none;
  transition: all 0.3s ease;
  width: 100%; /* Mobil uyum için genişlik %100 */
  max-width: 400px; /* Genişliği biraz artırdık */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 15px; /* Alanların arasına boşluk ekleyelim */
}

input[type="date"]:hover {
  border-color: #888;
  background-color: #f0f0f0;
}

input[type="date"]:focus {
  border-color: #007bff;
  background-color: #e9f5ff;
}


.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}
.pagination button {
  padding: 8px 12px;
  margin: 5px;
  border: none;
  background-color: #007bff;
  color: white;
  cursor: pointer;
  border-radius: 5px;
}
.pagination button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
</style>

<style scoped>
.header-container {
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
}

.left-section {
  justify-self: start;
}

.center-section {
  justify-self: center;
  width: 100%;
  max-width: 500px;
}

.right-section {
  justify-self: end;
  display: flex;
  gap: 10px;
}

.search-input {
  width: 100%;
  padding: 10px 15px;
  font-size: 16px;
  border-radius: 6px;
  border: 1px solid #ced4da;
  transition: all 0.3s ease;
}

.search-input:focus {
  border-color: #86b7fe;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  outline: none;
}

/* Mobil görünüm için düzenleme */
@media (max-width: 768px) {
  .header-container {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto;
    gap: 15px;
  }

  .left-section,
  .center-section,
  .right-section {
    justify-self: stretch;
  }

  .right-section {
    justify-content: space-between;
  }

  .center-section {
    order: -1; /* Arama kutusunu en üste taşır */
    max-width: 100%;
  }

  button {
    width: calc(50% - 5px); /* İki buton arasında küçük bir boşluk bırakır */
  }
}

/* Tablet görünümü için düzenleme */
@media (min-width: 769px) and (max-width: 1024px) {
  .header-container {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .center-section {
    max-width: 100%;
  }
}
</style>
